export const LOCALE_SET = 'LOCALE_SET';

export const setLocale = (locale) => ({
    type: LOCALE_SET,
    locale,
});
